'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIntl = require('react-intl');

exports.default = (0, _reactIntl.defineMessages)({
  empty: {
    id: 'xsui.charts.empty',
    defaultMessage: 'Not enough data available'
  },
  empty_descr: {
    id: 'xsui.charts.empty.description',
    defaultMessage: 'More data is needed to generate this graph.'
  },
  loading: {
    id: 'xsui.charts.loading',
    defaultMessage: 'Loading...'
  },
  fail: {
    id: 'xsui.charts.request-failed',
    defaultMessage: 'Loading failed'
  },
  fail_descr: {
    id: 'xsui.charts.request-failed.description',
    defaultMessage: 'Please check your connection and try again.'
  },
  fail_retry: {
    id: 'xsui.charts.request-failed.refresh',
    defaultMessage: 'Refresh graph'
  }
});